import request from '@/utils/request'

// 生成实时报表（前端展示）
export function generateRealTimeReport(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/report.generateRealTimeReport',
      method: 'post',
      data: params
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data || { headers: [], rows: [] })
      } else {
        reject(new Error(res.msg || '生成报表失败'))
      }
    }).catch(error => reject(error))
  })
}

// 导出报表（服务器端生成Excel下载）
export function exportRealTimeReport(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/report.exportRealTimeReport',
      method: 'post',
      data: params,
      responseType: 'blob'
    }).then(response => {
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${params.reportType}_${params.startMonth}_${params.endMonth}.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      resolve()
    }).catch(error => reject(error))
  })
}
